// Intestazione di una email: per le email scritte da me (inviate, bozze, in uscita) conta il destinatario, non il mittente
export const CARTELLE_MIE = new Set(["inviate", "bozze", "uscita"]);

export function scrittaDaMe(email) {
  return !!email && (CARTELLE_MIE.has(email.folder) || !!email.draft || email.categoria === "bozza");
}

// "Mario Rossi <mario@x.it>, \"Neri, Dario\" <d@n.it>, anna@y.it" → [{nome, email}, …] (virgole tra virgolette non separano)
export function parseIndirizzi(s) {
  const pezzi = [];
  let cur = "", quote = false, ang = false;
  for (const ch of String(s || "")) {
    if (ch === '"') quote = !quote;
    else if (ch === "<" && !quote) ang = true;
    else if (ch === ">" && !quote) ang = false;
    if ((ch === "," || ch === ";") && !quote && !ang) {
      pezzi.push(cur);
      cur = "";
    } else cur += ch;
  }
  pezzi.push(cur);
  return pezzi
    .map((x) => x.trim())
    .filter(Boolean)
    .map((x) => {
      const m = x.match(/^(.*?)\s*<([^>]+)>$/);
      const email = (m ? m[2] : x).trim();
      const nome = (m ? m[1] : "").replace(/^"|"$/g, "").trim();
      return { nome, email };
    });
}

// "Mario Rossi <mario@x.it>, anna@y.it" → "Mario Rossi +1"
export function destinatarioBreve(a) {
  const parti = parseIndirizzi(a);
  if (parti.length === 0) return "";
  const primo = parti[0].nome || parti[0].email;
  return parti.length > 1 ? `${primo} +${parti.length - 1}` : primo;
}

// Riga principale dell'intestazione: destinatario per le mie email, mittente per le ricevute
export function intestatario(email) {
  if (scrittaDaMe(email)) {
    const d = destinatarioBreve(email.a || email.draft?.a);
    return d ? `A: ${d}` : email.mittente;
  }
  return email.mittente;
}

// Testo dello stato di un invio in coda ("breve" per la lista, "lungo" per il dettaglio)
export function statoOutbox(o, forma = "breve") {
  if (o.stato === "fallita") return forma === "lungo" ? "Invio fallito dopo 24 ore di tentativi" : "Invio fallito";
  if (o.stato === "in_corso") return "Invio in corso…";
  return forma === "lungo" ? `In attesa: riprovo ogni 2 minuti (tentativo ${o.tentativi || 1})` : `In attesa (tentativo ${o.tentativi || 1})`;
}
